import NewReleaseForecasting from './new-release-forecasting';

export * from './new-release-forecasting';
export default NewReleaseForecasting;
